import { DATE_FORMAT } from "../constants/constants";
import { TIMEZONE } from "../constants/timezone";
import { CSV_DATE_TIME_FORMAT, DATE_TIME_FORMAT } from "../constants/util";
import dayjs from "./dayjs-init";

export const formatDate = (date, timezone, format = DATE_FORMAT) => {
  if (timezone === TIMEZONE.UTC) {
    return dayjs.utc(date).format(format);
  }
  return dayjs(date).format(format);
}

export const formatAmsDate = (date, format = DATE_FORMAT) => {
  if (!date) return "";

  const offsetMatch = date.match(/([+-]\d{2}:\d{2}|Z)$/);

  if (offsetMatch) {
    return dayjs(date).utcOffset(offsetMatch[0], true).format(format);
  }

  return dayjs.utc(date).format(format);
}

export const convertToTimezone = (date, timezone) => {
  if (timezone === TIMEZONE.UTC) {
    return dayjs.utc(date);
  }
  return dayjs(date);
}

export const getCurrentDateWithTimezone = (timezone) => {
  if (timezone === TIMEZONE.UTC) {
    return dayjs.utc();
  }
  return dayjs();
}

export const getLatestDatetime = (data, timezone) => {
  return timezone === TIMEZONE.UTC 
    ? dayjs.utc(Math.max(...data.map(e => new Date(e.dateTime)))).format(DATE_TIME_FORMAT)
    : dayjs.utc(Math.max(...data.map(e => new Date(e.dateTime)))).local().format(DATE_TIME_FORMAT);
}

export const getCurrentFormattedDateTimeTextWithTimezoneForCSV = (timezone) => {
    if (timezone === TIMEZONE.UTC) {
    return `${dayjs.utc().format(CSV_DATE_TIME_FORMAT)} (UTC)`;
  }
  return `${dayjs().format(CSV_DATE_TIME_FORMAT)} (LT)`;
}